import { render, staticRenderFns } from "./HelpCenterMainView.vue?vue&type=template&id=770b54f2"
import script from "./HelpCenterMainView.vue?vue&type=script&lang=js"
export * from "./HelpCenterMainView.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterMainView.vue?vue&type=style&index=0&id=770b54f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports